var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5122 1.8003C25.8322 4.12027 25.921 7.85335 23.714 10.281L12.6555 22.4444L1.59843 10.281C-0.608559 7.85331 -0.519678 4.12018 1.80029 1.80022C4.39066 -0.790157 8.65683 -0.553454 10.9453 2.30714L12.6562 4.44502L14.3657 2.3069C16.6542 -0.553697 20.9218 -0.790074 23.5122 1.8003Z",
    fill: "#253FF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteActive);
export default __webpack_public_path__ + "static/media/favourite-active.aade9eefe30577403d2e9b503ff25691.svg";
export { ForwardRef as ReactComponent };